var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequesRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8213 24.5218L24.4607 22.5859C25.3168 22.1304 26.9889 21.4395 26.9984 23.1477L27.613 22.7269C29.3375 21.546 30.651 22.3826 30.0059 24.0143C33.0717 21.7857 34.1556 24.6075 32.7901 25.3005L23.1302 31.4029C21.0954 32.6876 18.4103 32.7075 17.6547 32.2567C13.3622 31.1497 12.1241 30.0965 8.38184 30.5767",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57666 22.9366L11.0132 21.1333C12.1458 20.673 13.4131 20.7914 13.8908 21.145C14.6922 21.7391 15.4935 22.3324 16.2946 22.9259C19.6309 25.3978 19.9008 24.7805 23.8312 25.0148C24.7022 25.0665 25.2749 26.4689 23.8312 27.0241C20.1626 28.7015 17.8986 27.9491 14.5544 26.2374",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.974 5.47461C23.9284 5.47461 27.1341 8.68027 27.1341 12.6347C27.1341 16.5892 23.9284 19.7947 19.974 19.7947C16.0197 19.7947 12.814 16.5892 12.814 12.6347C12.814 8.68027 16.0197 5.47461 19.974 5.47461Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 10.002V15.002H19V12.5018",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15.002L17 10.002L21 10.002L21 12.5021",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_2798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9508,
    height: 28.2787,
    fill: "white",
    transform: "translate(6 4.82031)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequesRefund);
export default __webpack_public_path__ + "static/media/RequesRefund.3084abc7a526e5d2fd46b59b432f2f5a.svg";
export { ForwardRef as ReactComponent };